export default __webpack_public_path__ + "static/media/quality.0ffc9071.png";